import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Popover from "@mui/material/Popover";
import React, { useEffect, useState } from 'react';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import ExpandLessOutlinedIcon from '@mui/icons-material/ExpandLessOutlined';
import { selectFilterPaperStyle, titleFilterStyle, validationFilterButton, filterIconChipStyle, selectFilterMenuStyle } from '../Filter.style';
import { multiCheckboxStyle, multiMenuItemStyle } from './Multi.style';
import { Chip } from '../../Chip';
export const Multi = ({ filters, onSendFilters, title, label, dataQa, labelActionButton, hasValidation = false, paginationData }) => {
    const [filtersMulti, setFiltersMulti] = useState([]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleOpen = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    const handleChange = (value) => {
        const newFilters = [...filtersMulti];
        if (newFilters.find(f => f === value)) {
            const index = newFilters.indexOf(value);
            newFilters.splice(index, 1);
            sendData(newFilters);
        }
        else {
            if ([...newFilters, value].length === filters.length) {
                sendData([]);
            }
            else {
                sendData([...newFilters, value]);
            }
        }
    };
    const sendData = (value) => {
        setFiltersMulti(value);
        if (!hasValidation) {
            onSendFilters(value);
        }
        if (value.length === 0 && !hasValidation) {
            setAnchorEl(null);
        }
    };
    const handleSendFilters = () => {
        onSendFilters(filtersMulti);
        setAnchorEl(null);
    };
    const handleClickAway = (e) => {
        var _a;
        if (e.target.localName === "div" &&
            ((_a = e.target) === null || _a === void 0 ? void 0 : _a.className.indexOf("MuiBackdrop-root")) > -1 &&
            !hasValidation) {
            setAnchorEl(null);
        }
    };
    const handleDelete = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setFiltersMulti([]);
        onSendFilters([]);
    };
    const chipLabel = (label) => {
        let labelChip = label;
        if (filtersMulti && filtersMulti.length > 0) {
            const filtersTitleList = filtersMulti.map(filter => { var _a; return (_a = filters.find(f => f.value === filter)) === null || _a === void 0 ? void 0 : _a.title; });
            const value = filtersTitleList.length > 3
                ? `${[filtersTitleList[0], filtersTitleList[1], filtersTitleList[2]].join(', ')}, +${filtersTitleList.length - 3}`
                : filtersTitleList.join(', ');
            labelChip += ' | ' + value;
        }
        return labelChip;
    };
    useEffect(() => {
        if ((paginationData === null || paginationData === void 0 ? void 0 : paginationData.changePageOnFiltering) && (paginationData === null || paginationData === void 0 ? void 0 : paginationData.setPage)) {
            paginationData.setPage(0);
        }
    }, [filtersMulti]);
    return (React.createElement(ClickAwayListener, { onClickAway: handleClickAway, disableReactTree: true },
        React.createElement(Box, { "data-qa": dataQa },
            React.createElement(Chip, { "data-qa": `${dataQa}-chip`, label: chipLabel(label), onClick: handleOpen, variant: "outlined", selected: filtersMulti.length > 0, leftIcon: filtersMulti.length > 0
                    ? React.createElement(CancelIcon, { onClick: handleDelete, "data-qa": `${dataQa}-iconCancel` })
                    : React.createElement(AddCircleIcon, { "data-qa": `${dataQa}-iconAdd`, sx: filterIconChipStyle }), rightIcon: filtersMulti.length > 0
                    ? open
                        ? React.createElement(ExpandLessOutlinedIcon, null)
                        : React.createElement(ExpandMoreOutlinedIcon, { sx: { "&:hover": { cursor: "default" } } })
                    : undefined }),
            open ?
                React.createElement(Popover, { "data-qa": `${dataQa}-select`, sx: selectFilterMenuStyle, id: "popoverFilterDates", open: open, onClose: handleClose, anchorEl: anchorEl, PaperProps: {
                        sx: Object.assign(Object.assign({}, selectFilterPaperStyle), { width: '248px' })
                    } },
                    React.createElement(Box, { sx: titleFilterStyle },
                        React.createElement("h3", null, title)),
                    filters.map(filter => (React.createElement(MenuItem, { key: filter.value, value: filter.value, sx: multiMenuItemStyle, onClick: () => handleChange(filter.value) },
                        React.createElement(Checkbox, { "data-qa": `${dataQa}-checkbox`, checked: filtersMulti.indexOf(filter.value) > -1, sx: multiCheckboxStyle }),
                        React.createElement(ListItemText, { primary: filter.title })))),
                    hasValidation &&
                        React.createElement(Button, { "data-qa": `${dataQa}-validate`, color: "secondary", variant: "contained", onClick: handleSendFilters, fullWidth: true, sx: validationFilterButton }, labelActionButton))
                : null)));
};
